import { render, staticRenderFns } from "./viewbt.vue?vue&type=template&id=8aa88dca&scoped=true&"
import script from "./viewbt.vue?vue&type=script&lang=js&"
export * from "./viewbt.vue?vue&type=script&lang=js&"
import style0 from "./viewbt.vue?vue&type=style&index=0&id=8aa88dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa88dca",
  null
  
)

export default component.exports